import React, { useState } from 'react';

const NewsPreviewCard = ({ newsLinks }) => {
    const [visibleItems, setVisibleItems] = useState(6);
    const [showMoreLoading, setShowMoreLoading] = useState(false);

    const showMoreItems = () => {
        setVisibleItems(prevVisibleItems => prevVisibleItems + 6);
    };

    return (
        <div className="basic-info-card profile-section-box">
            <div className="basic-info-card-item news-header">
                <div className="subheading icon-header">
                    <span>
                        <i className="far fa-newspaper mr-2"></i>
						Related News
                    </span>
                </div>
            </div>

            <div className='news-container'>
                {newsLinks?.slice(0, visibleItems).map(({ title, imgUrl, newsUrl }, index) => (
                    <a href={newsUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                        key={imgUrl + index}
                    >
                        <div
                            className="basic-info-card-item news-card-image"
                        >
                            <div className='news-image'
                                style={{
                                    backgroundImage: `url("${encodeURI(imgUrl)}")`,
                                }}></div>
                            <div className='subheading news-title'>{title}</div>
                        </div>
                    </a>
                ))}
            </div>

            {visibleItems < newsLinks.length && (
                <div className='d-flex justify-content-center'>
                    <a className='btn btn-main btn-sm mt-4 mb-0' onClick={showMoreItems}>
                        {showMoreLoading ? (
                            <i className="fas fa-circle-notch fa-spin mr-2"></i>
                        ) : (
                            <i className="fas fa-arrow-circle-down mr-2"></i>
                        )}
						Show More
                    </a>
                </div>
            )}
        </div>
    )
}

export default NewsPreviewCard;
